import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface BarChartProps {
  title?: string;
  data?: Array<{ name: string; value: number }>;
  height?: number;
  horizontal?: boolean;
}

const BarChart: React.FC<BarChartProps> = ({
  title,
  data = [
    { name: 'Aspirin', value: 420 },
    { name: 'Paracetamol', value: 380 },
    { name: 'Ibuprofen', value: 350 },
    { name: 'Amoxicillin', value: 300 },
    { name: 'Metformin', value: 250 },
    { name: 'Lisinopril', value: 240 },
    { name: 'Atorvastatin', value: 220 },
    { name: 'Omeprazole', value: 200 },
    { name: 'Vitamin C', value: 180 },
    { name: 'Calcium', value: 150 },
  ],
  height = 350,
  horizontal = false,
}) => {
  const chartOptions: ApexOptions = {
    chart: {
      type: horizontal ? 'bar' : 'bar',
      toolbar: {
        show: false,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
      },
    },
    colors: ['#0284c7'],
    plotOptions: {
      bar: {
        horizontal: horizontal,
        dataLabels: {
          position: 'top',
        },
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: data.map((d) => d.name),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
          fontWeight: 500,
        },
      },
    },
    grid: {
      show: true,
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      theme: 'light',
      style: {
        fontSize: '12px',
      },
    },
  };

  const series = [
    {
      name: title || 'Items Sold',
      data: data.map((d) => d.value),
    },
  ];

  return (
    <ReactApexChart
      options={chartOptions}
      series={series}
      type={horizontal ? 'bar' : 'bar'}
      height={height}
      width="100%"
    />
  );
};

export default BarChart;
